/*
 * Copyright (c) Fing Ltd. All rights reserved.
 */

import React, { Component } from 'react';
import {withRouter} from "react-router-dom";

import { isUserSignedIn, UserContext } from "../UserContext";
import WaitingComponent from "../components/WaitingComponent";
import AccountNavbar from "./AccountNavbar";
import AppFooter from "../components/AppFooter";
import AccountSignedOutEmptyState from "./AccountSignedOutEmptyState";
import AccountConnectionSummary from "./AccountConnectionSummary";
import AccountSubscriptionSummary from "./AccountSubscriptionSummary";
import AccountAppsSummary from "./AccountAppsSummary";
import AccountProfileSummary from './AccountProfileSummary';
import AccountNotificationsSummary from './AccountNotificationsSummary';
import AccountMonitoringAgentsSummary from "./AccountMonitoringAgentsSummary";

class AccountDashboard extends Component {

    static contextType = UserContext;

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        document.title = "Fing - Account dashboard";
    }

    validateRestResponse(response) {
        if (response.status !== 200) {
            throw Error(response.statusText);
        }
        return response;
    }

    catchRestError(response) {
    }


    render() {
        return (
            <div>
                <AccountNavbar mode='account' />

                <main id="content" role="main">
                    {this.renderMainContent()}
                </main>

                <AppFooter />
            </div>
        );
    }

    renderMainContent() {
        return (
            <UserContext.Consumer>
                {userContext => this.renderMainContentInContext(userContext)}
            </UserContext.Consumer>
        )
    }

    renderMainContentInContext(userContext) {
        if (!userContext || !userContext.userProfileLoaded) {
            return <div className="container space-2">
                <div className="row mt-3">
                    <div className="col-lg-12 text-center">
                        <WaitingComponent className="my-3" />
                    </div>
                </div>
            </div>;
        } else if (isUserSignedIn(userContext) && userContext.stripePublicApiKey) {
            return this.renderMainContentSignedIn(userContext);
        } else {
            return this.renderMainContentPromo();
        }
    }

    renderMainContentSignedIn(userContext) {
        return (
            <div className="bg-light">
                <div className="container space-1">

                    <div className="row my-4">
                        <div className="col-sm-12 col-md-3 py-2">
                            <h4>Personal info</h4>
                        </div>
                        <div className="col-sm-12 col-md-9">
                            <AccountProfileSummary userProfile={userContext.userProfile} />
                        </div>
                    </div>

                    <div className="row my-4">
                        <div className="col-sm-12 col-md-3 py-2">
                            <h4>Notifications settings</h4>
                        </div>
                        <div className="col-sm-12 col-md-9">
                            <AccountNotificationsSummary />
                        </div>
                    </div>

                    <div className="row my-4">
                        <div className="col-sm-12 col-md-3 py-2">
                            <h4>Subscription plan</h4>
                        </div>
                        <div className="col-sm-12 col-md-9">
                            <AccountSubscriptionSummary />
                        </div>
                    </div>

                    <div className="row my-4">
                        <div className="col-sm-12 col-md-3 py-2">
                            <h4>Monitoring agents</h4>
                        </div>
                        <div className="col-sm-12 col-md-9">
                            <AccountMonitoringAgentsSummary userProfile={userContext.userProfile} />
                        </div>
                    </div>

                    <div className="row my-4">
                        <div className="col-sm-12 col-md-3 py-2">
                            <h4>Connected devices</h4>
                        </div>
                        <div className="col-sm-12 col-md-9">
                            <AccountConnectionSummary userProfile={userContext.userProfile} />
                        </div>
                    </div>

                    <div className="row my-4">
                        <div className="col-sm-12 col-md-3 py-2">
                            <h4>Authorized apps</h4>
                        </div>
                        <div className="col-sm-12 col-md-9">
                            <AccountAppsSummary userProfile={userContext.userProfile} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderMainContentPromo() {
        return <AccountSignedOutEmptyState />;
    }

}

export default withRouter(AccountDashboard)